import { Color } from "./Color/Color"
import { Typography } from "./Typography/Typography"

const types = {
    Kleuren: Color,
    Typografie: Typography
}

export default types